<template>
  <sanitas-branding-wrapper :header="header">
    <sanitas-branding-filter-short
      v-if="!fullVersion"
      :default-values="defaultValues"
      :drop-downs="dropDowns"
      :radio-data="radioData"
      :fatpagepath="fatpagepath"
    ></sanitas-branding-filter-short>
    <sanitas-branding-filter-full
      v-else
      :default-values="defaultValues"
      :drop-downs="dropDowns"
      :radio-data="radioData"
    ></sanitas-branding-filter-full>
  </sanitas-branding-wrapper>
</template>

<script>
import { provideI36n, useI36n } from '@jota-one/i36n/src/index.vue2'
import axios from 'axios'
import get from 'lodash/get'

import SanitasBrandingFilterFull from './components/Full'
import SanitasBrandingFilterShort from './components/Short'
import SanitasBrandingWrapper from './layout/Wrapper'

export default {
  name: 'SanitasBrandingFilter',
  components: {
    SanitasBrandingFilterFull,
    SanitasBrandingFilterShort,
    SanitasBrandingWrapper,
  },
  props: {
    header: {
      type: Boolean,
      default: true,
    },
    fullVersion: Boolean,
    fatpagepath: {
      type: String,
      default: '/de/ueber-sanitas/arbeiten-bei-sanitas/offene-stellen.html',
    },
    serverUrl: {
      type: String,
      default: 'https://ohws.prospective.ch/public/v1/medium/1002048',
    },
  },

  setup() {
    const language = window.Sanitas.language || 'de'
    const loadLabels = lang => import(`./i18n/${lang}.json`)
    provideI36n(language, { load: loadLabels })
    const { $label } = useI36n()

    return {
      $t: $label,
    }
  },

  data: () => ({
    defaultValues: {},
    attributes: [],
  }),
  computed: {
    dropDowns() {
      const { fullVersion, attributes } = this
      const arry = fullVersion ? [30, 20, 50] : [20, 30]
      const items = arry.map(el =>
        attributes.find(item => Number(item.id) === el),
      )
      return items.map(elem => {
        return this.formatElement(elem)
      })
    },
    // id === 40: radio button
    radioData() {
      return this.formatElement(
        this.attributes.find(el => Number(el.id) === 40),
      )
    },
  },
  created() {
    axios
      .get(`${this.serverUrl}/attributes?lang=${this.language}`)
      .then(({ data }) => {
        const { attributes } = data || {}
        this.attributes = attributes
      })
    window.addEventListener('hashchange', () => {
      this.readFromUrl()
    })
    this.readFromUrl()
  },
  methods: {
    readFromUrl() {
      let match
      const pl = /\+/g
      const search = /([^&=]+)=?([^&]*)/g
      const decode = s => decodeURIComponent(s.replace(pl, ' '))
      const query = window.location.hash.substring(1)
      this.defaultValues = {}
      while ((match = search.exec(query))) {
        const key = decode(match[1])
        const value = decode(match[2])
        if ([30, 20, 50].includes(Number(key))) {
          if (this.defaultValues[key]) {
            this.defaultValues[key].push(value)
          } else {
            this.defaultValues[key] = []
            this.$set(this.defaultValues[key], 0, value)
          }
        } else {
          this.$set(this.defaultValues, key, value)
        }
      }
    },
    getTitle(id) {
      const el = Number(id)
      switch (el) {
        case 20:
          return this.$t('activity-area')
        case 30:
          return this.$t('workplace')
        case 50:
          return this.$t('employment-level')
        default:
          return ''
      }
    },
    formatElement(elem) {
      return elem
        ? {
            id: get(elem, 'id'),
            title: this.getTitle(get(elem, 'id')),
            items: Object.keys(get(elem, 'values')).map(key => {
              return {
                text: get(elem, ['values', key]),
                value: key,
              }
            }),
          }
        : {}
    },
  },
}
</script>

<style lang="postcss"></style>
